<template>
  <div>
    <!--begin::Dashboard-->
    <DemoBlocks :dates="dates" :selected-domains="selectedDomains" />
    <v-row>
      <v-col cols="12">
        <DemoTable :dates="dates" :selected-domains="selectedDomains" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import DemoBlocks from "@/components/Demo/DemoBlocks";
import DemoTable from "@/components/Demo/DemoTable";
import domainsAndDateSelection from "@/core/mixins/domainsAndDateSelection.mixin";

export default {
  name: "dashboard",
  components: {
    DemoTable,
    DemoBlocks
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Dashboard" }]);
  },
  mixins: [domainsAndDateSelection],
  data() {
    return {
      calendar: false
    };
  }
};
</script>
